import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Icon } from 'semantic-ui-react';
import { ServiceWorkerContext } from './global/cnr/contexts/ServiceWorkerContext';
import { currentHelpers } from './global/redirection/current';

const WAIT_INTERVAL = 4000
const _storageKey = 'hasSeenUpdatePromptRecently'

export const installAppTypes = {
  auto: 'auto',
  help: 'help',
  manual: 'manual',
}

const NewVersion = () => {

  const serviceWorkerContext = useContext(ServiceWorkerContext)
  const { serviceWorker_state } = serviceWorkerContext ?? {}
  const { serviceWorker } = serviceWorker_state ?? {}
  const { newVersionAvailable, newVersionNumber, updateRegistration } = serviceWorker ?? {}

  const [allow, setAllow] = useState()

  useEffect(() => {
    const timer = setTimeout(() => {
      const seen = currentHelpers.storageItem_get(_storageKey);

      const seenTime = Number(seen);
      const recentlySeen = seenTime && Date.now() - seenTime < 6 * 60 * 60 * 1000;
      if (!recentlySeen) {
        setAllow(true);
      }

    }, WAIT_INTERVAL);
    return () => clearTimeout(timer);
  }, []);

  const handleUpdateVersion = async () => {
    updateRegistration()
  };

  const handleClickNo = () => {
    currentHelpers.storageItem_set(_storageKey, new Date().getTime().toString())
    setAllow(false);
  };

  let cn = 'app-homepage'

  const content = () => <div className={cn}>
    <Card fluid as='div'>
      <Card.Content>
        <Icon style={{ float: 'right' }} float='right' name='refresh' />
        <Card.Header>{'New Version Available'}</Card.Header>
        <Card.Description>{'A new version (' + newVersionNumber + ') is available. Please update.'}</Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div className='ui two buttons'>
          <Button basic color='green' onClick={(e) => { handleUpdateVersion(e) }}>
            Update
          </Button>
          <Button basic color='red' onClick={(e) => { handleClickNo(e) }}>
            Later
          </Button>
        </div>
      </Card.Content>
    </Card>
  </div>

  return allow && newVersionAvailable ? content() : <div></div>
};

export default NewVersion;
